import type { MouseEvent as ReactMouseEvent } from "react";

/**
 * Inline confirmation row used to gate irreversible-ish actions on the
 * reservation and waitlist cards — same visual language across both lists
 * so the host learns one pattern. Slots into the bottom of a card,
 * replacing the action button row while the confirm is open.
 */
export function CardConfirmRow({
  tone,
  label,
  yesLabel,
  onYes,
  onNo,
}: {
  tone: "red" | "warn" | "go";
  label: string;
  yesLabel: string;
  onYes: (e: ReactMouseEvent) => void;
  onNo: (e: ReactMouseEvent) => void;
}) {
  const palette =
    tone === "red"
      ? {
          border: "border-[#b13030]",
          bg: "bg-[#fcebeb]",
          text: "text-[#b13030]",
          yes: "bg-[#b13030] text-white",
          no: "border-[#b13030] text-[#b13030]",
        }
      : tone === "warn"
        ? {
            border: "border-[#b88a00]",
            bg: "bg-[#fff2c4]",
            text: "text-[#8a6d00]",
            yes: "bg-[#b88a00] text-white",
            no: "border-[#b88a00] text-[#8a6d00]",
          }
        : {
            border: "border-[#111]",
            bg: "bg-[#f7f6f3]",
            text: "text-[#111]",
            yes: "bg-[#111] text-white",
            no: "border-[#111] text-[#111]",
          };
  return (
    <div
      className={`mt-2 flex items-center gap-2.5 rounded-lg border px-3 py-2.5 ${palette.border} ${palette.bg}`}
    >
      <div className={`flex-1 text-[13px] font-semibold ${palette.text}`}>{label}</div>
      <div className="flex gap-1.5">
        <button
          type="button"
          onClick={onYes}
          className={`min-h-9 rounded-lg px-3 text-xs font-semibold ${palette.yes}`}
        >
          {yesLabel}
        </button>
        <button
          type="button"
          onClick={onNo}
          className={`min-h-9 rounded-lg border px-3 text-xs font-medium ${palette.no}`}
        >
          No
        </button>
      </div>
    </div>
  );
}
